 document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    document.querySelectorAll('[data-prevent-autoplay="true"]').forEach(function (section) {
      if (!section) return;

      // Kill autoplay ONLY within this section
      section.querySelectorAll('video-media[autoplay] video').forEach(function(video) {
        video.pause();
        video.removeAttribute('autoplay');
        video.currentTime = 0;
        const parent = video.closest('video-media');
        if (parent) parent.removeAttribute('autoplay');

        video.style.pointerEvents = 'auto';
        video.style.cursor = 'pointer';

        video.addEventListener('click', function () {
          video.paused ? video.play() : video.pause();
        });
      });

      // Play button logic scoped to this section
      section.querySelectorAll('video-media.video-with-play-button').forEach(function(wrapper) {
        const video = wrapper.querySelector('video');
        if (!video) return;

        wrapper.style.position = 'relative';

        const overlay = document.createElement('div');
        overlay.className = 'custom-video-click-overlay';
        wrapper.appendChild(overlay);

        const playBtn = document.createElement('div');
        playBtn.className = 'custom-play-button';
        playBtn.innerHTML = `
          <svg role="presentation" fill="none" focusable="false" class="icon icon-play-button" viewBox="0 0 48 48">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M24 48C10.745 48 0 37.255 0 24S10.745 0 24 0s24 10.745 24 24-10.745 24-24 24Zm-3-19.15a.3.3 0 0 0 .462.253l7.545-4.85a.3.3 0 0 0 0-.505l-7.545-4.85a.3.3 0 0 0-.462.252v9.7Z" fill="currentColor"></path>
          </svg>
        `;
        wrapper.appendChild(playBtn);

        let fakeHoverInterval = null;

        const showButton = () => {
          playBtn.style.opacity = '1';
          playBtn.style.pointerEvents = 'auto';
          video.removeAttribute('controls');
        };

        const hideButton = () => {
          playBtn.style.opacity = '0';
          playBtn.style.pointerEvents = 'none';
          video.setAttribute('controls', 'controls');
          video.controls = true;
          video.muted = false;

          if (!fakeHoverInterval) {
            fakeHoverInterval = setInterval(() => {
              video.dispatchEvent(new Event('mousemove'));
            }, 2000);
          }
        };

        const stopFakeHover = () => {
          if (fakeHoverInterval) {
            clearInterval(fakeHoverInterval);
            fakeHoverInterval = null;
          }
        };

        playBtn.addEventListener('click', function (e) {
          e.preventDefault();
          video.paused ? video.play() : video.pause();
        });

        overlay.addEventListener('click', function () {
          video.paused ? video.play() : video.pause();
        });

        video.addEventListener('play', hideButton);
        video.addEventListener('pause', () => {
          stopFakeHover();
          showButton();
        });

        video.paused ? showButton() : hideButton();
      });
    });
  }, 400); // slight delay to let Impact's autoplay scripts run first
});



document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.marquee-text').forEach(marquee => {
        const marqueeTrack = marquee.querySelector('.marquee-text-track');
        const items = Array.from(marqueeTrack.children);
        
        // Check if there are items to scroll
        if (items.length === 0) {
            console.warn("No marquee items found. Add blocks to enable scrolling.");
            return; // Exit the function if no items are found
        }

        let contentWidth = 0;

        // Calculate the total width of the original content, including separators
        items.forEach(item => { 
            contentWidth += item.offsetWidth; 
        });

        // Duplicate content to ensure enough width for seamless scrolling
        const containerWidth = marquee.clientWidth;
        while (contentWidth < containerWidth * 2) { 
            items.forEach(item => {
                const clone = item.cloneNode(true);
                marqueeTrack.appendChild(clone);
                contentWidth += clone.offsetWidth;
            });
        }

        // Retrieve scroll duration based on screen width
        const isMobile = window.innerWidth <= 768;
        const scrollDuration = parseFloat(
            marquee.dataset[isMobile ? 'scrollDurationMobile' : 'scrollDurationDesktop']
        ) || 20;

        // Calculate the pixels per second required for smooth scrolling
        const pixelsPerSecond = contentWidth / scrollDuration;
        let scrollPosition = 0;

        // Animation function for smooth, seamless scrolling
        function animateMarquee() {
            scrollPosition -= pixelsPerSecond / 60; // Approximate 60 FPS

            // Reset scroll position to ensure seamless looping
            if (Math.abs(scrollPosition) >= contentWidth / 2) {
                scrollPosition = 0;
            }

            marqueeTrack.style.transform = `translateX(${scrollPosition}px)`;
            requestAnimationFrame(animateMarquee);
        }

        // Start the animation
        requestAnimationFrame(animateMarquee);
    });
});



(function() {
  function refreshAfterpay(amountCents) {
    const el = document.querySelector('square-placement[data-amount]');
    if (!el) return;

    // Update the widget’s data-amount attribute
    el.setAttribute('data-amount', (amountCents / 100).toFixed(2));

    // Re-init Afterpay if possible
    if (window.Afterpay?.initialize) {
      window.Afterpay.initialize();
    } else if (window.Afterpay?.refresh) {
      window.Afterpay.refresh();
    } else if (window.Clearpay?.initialize) {
      window.Clearpay.initialize();
    }
  }

  function getCurrentVariantPrice() {
    const jsonEl = document.querySelector('variant-picker script[type="application/json"]');
    if (!jsonEl) return null;
    try {
      const data = JSON.parse(jsonEl.textContent);
      return data?.price || null;
    } catch(e) {
      console.warn('Could not parse current variant JSON', e);
      return null;
    }
  }

  // Hook into your theme’s event
  window.addEventListener('variant:change', (e) => {
    const variant = e.detail?.variant;
    if (variant) {
      refreshAfterpay(variant.price);
    }
  });

  // Fallback for direct clicks on radios
  document.addEventListener('change', (e) => {
    if (e.target.closest('.variant-picker')) {
      const price = getCurrentVariantPrice();
      if (price) refreshAfterpay(price);
    }
  });

  // Kick it once on load with the current variant price
  document.addEventListener('DOMContentLoaded', () => {
    const price = getCurrentVariantPrice();
    if (price) refreshAfterpay(price);
  });
})();

